import styled, { keyframes, createGlobalStyle } from 'styled-components';

export const UpsellGlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0;
    padding: 0;
    background: transparent !important;
    min-height: 0 !important;
  }
`;


const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  width: 100%;
  padding: 0;
  margin: 0;
  background: transparent;

  button {
    width: 100%;
    border: none;
    border-radius: 8px;
    padding: 14px;
    font-size: 0.95rem;
    cursor: pointer;
    transition: opacity 0.2s;
    color: #fff;
    box-sizing: border-box;

    &.accept {
      font-weight: 600;
    }

    &.reject {
      background: rgba(0, 0, 0, 0.05);
      color: #555;
      font-weight: 500;
    }

    &:hover {
      opacity: 0.9;
    }
  }
`;

export const SkeletonButton = styled.div`
  width: 100%;
  height: 46px;
  border-radius: 8px;
  background: linear-gradient(90deg, #e5e7eb 0px, #f3f4f6 40px, #e5e7eb 80px);
  background-size: 200px 100%;
  animation: ${shimmer} 1.2s infinite linear;
  box-sizing: border-box;
`;

export const ErrorMessage = styled.p`
  margin: 0;
  font-size: 0.8rem;
  color: ${({ theme }) => theme.baseTextSecondary};
  text-align: center;
  opacity: 0.9;
  width: 100%;
`;

const pop = keyframes`
  0% {
    transform: scale(0.9);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const SuccessBox = styled.div`
  animation: ${pop} 0.3s ease-out;
  padding: 16px;
  border-radius: 10px;
  background: #ecfdf5;
  border: 1px solid #a7f3d0;
  text-align: center;
  color: #065f46;

  strong {
    display: block;
    margin-top: 8px;
    font-size: 1rem;
  }

  p {
    margin: 6px 0 0;
    font-size: 0.85rem;
    opacity: 0.9;
  }

  .checkmark {
    margin: 0 auto;
    width: 32px;
    height: 32px;
    position: relative;
  }

  .circle {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #10b981;
    display: block;
  }

  .tick {
    position: absolute;
    top: 8px;
    left: 10px;
    width: 12px;
    height: 20px;
    border: solid #fff;
    border-width: 0 3px 3px 0;
    transform: rotate(45deg);
  }
`;

export const ProcessingBox = styled.div`
  animation: ${pop} 0.3s ease-out;
  padding: 16px;
  border-radius: 10px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  text-align: center;
  color: #1d4ed8;

  strong {
    display: block;
    margin-top: 10px;
    font-size: 1rem;
  }

  p {
    margin: 6px 0 0;
    font-size: 0.85rem;
    opacity: 0.9;
  }

  .spinner {
    display: inline-block;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 3px solid rgba(29, 78, 216, 0.15);
    border-top-color: #2563eb;
    animation: ${spin} 0.8s linear infinite;
  }
`;

export const RefusedBox = styled.div`
  padding: 16px;
  border-radius: 10px;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  text-align: center;
  color: #92400e;

  strong {
    display: block;
    font-size: 1rem;
    margin-bottom: 6px;
  }

  p {
    font-size: 0.85rem;
    opacity: 0.9;
    margin-bottom: 14px;
  }

  .recover-offer {
    width: 100%;
    background: #f59e0b;
    color: #fff;
    padding: 10px 14px;
    font-size: 0.85rem;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    font-weight: 600;
  }

  .recover-offer:hover {
    opacity: 0.9;
  }
`;

export const RecurringCard = styled.div`
  padding: 14px 16px;
  border-radius: 10px;
  background: rgba(16, 185, 129, 0.08);
  border: 1px solid rgba(16, 185, 129, 0.2);
  color: #065f46;

  .badge {
    display: inline-flex;
    margin-bottom: 8px;
    padding: 4px 8px;
    border-radius: 999px;
    background: rgba(16, 185, 129, 0.14);
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  strong {
    display: block;
    font-size: 1rem;
    line-height: 1.2;
  }

  p {
    margin: 6px 0 0;
    font-size: 0.85rem;
    line-height: 1.4;
    color: rgba(6, 95, 70, 0.9);
  }

  .summary {
    display: grid;
    gap: 4px;
    margin-top: 10px;
  }

  .primary {
    font-size: 0.95rem;
    font-weight: 700;
  }

  .secondary {
    font-size: 0.82rem;
    color: rgba(6, 95, 70, 0.85);
    font-weight: 600;
  }
`;
